import UnconstrainedForecast from './unconstrainedForecast';

export default UnconstrainedForecast;
